export default "__VITE_ASSET__DMT516fZ__"